import { createSelector } from "reselect";

const getProfileView = (state: any) => state.getIn(['profileViewReducer', 'profileView']);
const findgetProfileViewError = (state: any) => state.getIn(["profileViewReducer", "getProfileViewError"]);
const getNameInHeader = (state: any) => state.getIn(["profileViewReducer", "nameInHeader"]);
const getProfileError = (state: any) => state.getIn(["profileViewReducer", "profileViewError"]);

const ProfileViewSelector = createSelector(
  [getProfileView, findgetProfileViewError, getNameInHeader, getProfileError ],
  (
    profileView,

    getProfileViewError,
    nameInHeader,
    profileViewError
  ) => ({
    profileView,

    getProfileViewError,
    nameInHeader,
    profileViewError

  })
);
export default ProfileViewSelector;